/* Creation request fulfillment: provider success -> submitted-email Brevo event. */
(function () {
  'use strict';
  const roots = document.querySelectorAll('[data-maf-creation-download]');
  // Brevo uses document-wide IDs. Refuse ambiguous inline form installations.
  if (roots.length !== 1 || document.querySelectorAll('#sib-form').length !== 1) return;
  const root = roots[0];
  if (root.dataset.editorSuccessPreview === 'true') {
    root.dataset.trackingStatus = 'editor_preview';
    return;
  }
  if (root.dataset.initialized) return;
  const form = root.querySelector('#sib-form');
  const success = root.querySelector('#success-message');
  const error = root.querySelector('#error-message');
  const result = root.querySelector('[data-creation-pdf-success]');
  if (!form || !success || !error || !result) return;
  root.dataset.initialized = 'true';
  let pending = false;
  let optedIn = false;
  let completed = false;
  // Explicit instruction-email fulfillment is independent of analytics consent.
  // Legacy analytics-only installations still honor the app-owned consent gate.
  // This component never installs a second tracker or calls a private API.
  const fulfillmentEnabled = root.dataset.fulfillmentEnabled === 'true';
  const trackingEnabled = root.dataset.brevoTracking === 'true';
  const requestEnabled = fulfillmentEnabled || trackingEnabled;
  root.dataset.trackingStatus = requestEnabled ? 'idle' : 'disabled';
  let eventPayload = null;
  function trackingAllowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.userCanBeTracked === 'function' && privacy.userCanBeTracked());
    } catch (_) { return false; }
  }
  function trackerClientKey() {
    // Explicit public browser key lets fulfillment work with no analytics SDK.
    // Do not fall back to loading a tracker or reading cookies.
    if (fulfillmentEnabled) {
      const key = root.dataset.brevoPublicKey || '';
      return /^[a-zA-Z0-9_-]{10,100}$/.test(key) ? key : null;
    }
    // Legacy analytics mode reads the existing app-owned SDK public key.
    const script = document.getElementById('sendinblue-js');
    if (!script || !script.src) return null;
    try {
      const url = new URL(script.src);
      if (url.origin !== 'https://sibautomation.com' || url.pathname !== '/sa.js') return null;
      const key = url.searchParams.get('key');
      return key && /^[a-zA-Z0-9_-]{10,100}$/.test(key) ? key : null;
    } catch (_) { return null; }
  }
  function sendRequestEvent(body, attempt) {
    if (!requestEnabled) return;
    if (!fulfillmentEnabled && !trackingAllowed()) { root.dataset.trackingStatus = 'consent_denied'; return; }
    const key = trackerClientKey();
    if (!key) {
      if (fulfillmentEnabled) { root.dataset.trackingStatus = 'configuration_missing'; return; }
      if (attempt < 20) {
        root.dataset.trackingStatus = 'awaiting_sdk';
        setTimeout(function () { sendRequestEvent(body, attempt + 1); }, 250);
      } else { root.dataset.trackingStatus = 'sdk_unavailable'; }
      return;
    }
    const eventData = { id: body.request_id, data: {
      request_id: body.request_id,
      requested_at: body.requested_at,
      creation_handle: body.creation_handle,
      creation_title: body.creation_title,
      pdf_url: body.pdf_url,
      pdf_filename: body.pdf_filename,
      market: body.market,
      form_version: body.form_version,
      consent_profile: body.consent_profile,
      marketing_opt_in_selected: body.marketing_opt_in_selected,
      environment: window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main' ? 'production' : 'qa',
      source: 'creation_form_success',
      identity_mode: 'submitted_email',
      purpose: fulfillmentEnabled ? 'requested_instructions' : 'analytics'
    } };
    // Mirrors the currently installed public SDK's /p JSON transport. Unlike
    // SDK track(), use a fresh request-scoped cuid, never the browser cookie's
    // sticky identity. Both email fields name this submission. No contact attributes.
    const request = {
      key: key,
      cuid: body.request_id,
      sib_type: 'track',
      sib_name: 'creation_download_requested',
      email_id: body.email,
      contact: { email_id: body.email },
      ma_url: window.location.origin + window.location.pathname,
      event: eventData
    };
    if (fulfillmentEnabled && (!body.pdf_url || !body.email)) {
      root.dataset.trackingStatus = 'invalid_request';
      return;
    }
    root.dataset.trackingStatus = 'sending';
    try {
      fetch('https://in-automate.brevo.com/p', {
        method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
        keepalive: true, referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        body: JSON.stringify(request)
      }).then(function (response) {
        root.dataset.trackingStatus = response.ok ? 'sent' : 'tracking_failed';
      }).catch(function () { root.dataset.trackingStatus = 'tracking_failed'; });
    } catch (_) { root.dataset.trackingStatus = 'tracking_failed'; }
    // No blind retries: transport failure can be an uncertain acceptance.
    // No email in DOM events, analytics, URLs, console or persistent storage.
  }
  const captcha = root.querySelector('[data-creation-captcha]');
  const captchaStatus = root.querySelector('[data-creation-captcha-status]');
  const submit = form.querySelector('button[type="submit"]');
  let verified = false;
  let widgetId = null;
  let loading = false;
  let loadTimer;
  const dialog = root.closest('dialog');
  function status(message) { if (captchaStatus) captchaStatus.textContent = message; }
  function invalidate(message) {
    verified = false;
    if (submit) submit.disabled = true;
    status(message);
  }
  if (submit) submit.disabled = true;
  function renderCaptcha() {
    if (!captcha || completed || (dialog && !dialog.open)) return;
    if (!window.turnstile || typeof window.turnstile.render !== 'function') return;
    if (widgetId !== null) return;
    clearTimeout(loadTimer);
    loading = false;
    window.grecaptcha = window.turnstile;
    status('Checking that you’re human…');
    try {
      widgetId = window.turnstile.render(captcha, {
        sitekey: captcha.dataset.sitekey,
        language: captcha.dataset.language || 'en',
        appearance: 'always',
        theme: 'light',
        size: captcha.clientWidth > 0 && captcha.clientWidth < 300 ? 'compact' : 'normal',
        callback: function () {
          verified = true;
          if (submit) submit.disabled = false;
          status('Verification complete');
          captcha.dispatchEvent(new Event('captchaChange'));
        },
        'expired-callback': function () { invalidate('Verification expired. Please complete it again.'); },
        'timeout-callback': function () { invalidate('Verification timed out. Please retry the challenge.'); },
        'error-callback': function (code) {
          invalidate('Verification could not load (code ' + String(code) + '). Please reload this preview.');
        }
      });
    } catch (_) {
      invalidate('Verification could not initialize. Please reload this preview.');
    }
  }
  function ensureCaptcha() {
    if (completed || !captcha || (dialog && !dialog.open)) return;
    if (window.turnstile && typeof window.turnstile.render === 'function') { renderCaptcha(); return; }
    if (loading) return;
    loading = true;
    status('Checking that you’re human…');
    window.mafCreationTurnstileReady = renderCaptcha;
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=mafCreationTurnstileReady';
    script.async = true;
    script.onerror = function () { clearTimeout(loadTimer); invalidate('Verification script could not load. Please check content blockers and reload.'); };
    loadTimer = setTimeout(function () { invalidate('Verification is taking too long to load. Please reload this preview.'); }, 15000);
    document.head.appendChild(script);
  }
  if (dialog) new MutationObserver(ensureCaptcha).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  ensureCaptcha();
  const active = node => node.classList.contains('sib-form-message-panel--active');
  form.addEventListener('submit', function (event) {
    if (!verified) {
      event.preventDefault();
      event.stopImmediatePropagation();
      invalidate('Please complete verification before requesting instructions.');
      return;
    }
    if (completed) return;
    pending = true;
    const checkbox = form.querySelector('[name="OPT_IN"]');
    optedIn = !!(checkbox && checkbox.checked);
    if (requestEnabled && (fulfillmentEnabled || trackingAllowed()) && window.crypto && typeof window.crypto.randomUUID === 'function') {
      const email = form.querySelector('[name="EMAIL"]');
      const pdfLink = result.querySelector('a[href]');
      let pdfUrl = '';
      try {
        const url = new URL(pdfLink.href);
        const storeFile = (url.origin === 'https://cdn.shopify.com' && url.pathname.startsWith('/s/files/')) ||
          ((url.origin === 'https://www.makeafort.fun' ||
            (url.protocol === 'https:' && url.origin === window.location.origin)) &&
            url.pathname.startsWith('/cdn/shop/files/'));
        if (storeFile && url.pathname.toLowerCase().endsWith('.pdf') && !url.username && !url.password) pdfUrl = url.href;
      } catch (_) { /* No valid file context means email automation must not send. */ }
      eventPayload = {
        request_id: window.crypto.randomUUID(),
        email: email ? email.value.trim() : '',
        requested_at: new Date().toISOString(),
        creation_handle: root.dataset.creationHandle,
        creation_title: root.dataset.creationTitle,
        pdf_url: pdfUrl,
        pdf_filename: root.dataset.creationHandle + '-instructions.pdf',
        market: root.dataset.market,
        form_version: root.dataset.formVersion,
        consent_profile: root.dataset.consentProfile || 'non-gdpr',
        marketing_opt_in_selected: optedIn
      };
    }
    // Clear stale provider state before a retry. A submit click alone unlocks nothing.
    success.classList.remove('sib-form-message-panel--active');
    error.classList.remove('sib-form-message-panel--active');
    result.hidden = true;
  }, true);
  const observer = new MutationObserver(function () {
    if (!pending || completed) return;
    if (active(error)) { pending = false; eventPayload = null; return; }
    if (!active(success)) return;
    completed = true;
    pending = false;
    form.hidden = true;
    success.hidden = true;
    result.hidden = false;
    if (eventPayload) sendRequestEvent(eventPayload, 0);
    eventPayload = null;
    // Local extension point only: this does NOT persist an event in Brevo/GA4.
    root.dispatchEvent(new CustomEvent('maf:creation:request-accepted', {
      bubbles: true,
      detail: {
        creation_handle: root.dataset.creationHandle,
        creation_title: root.dataset.creationTitle,
        market: root.dataset.market,
        form_version: root.dataset.formVersion,
        marketing_opt_in_selected: optedIn
      }
    }));
    observer.disconnect();
  });
  observer.observe(success, { attributes: true, attributeFilter: ['class'] });
  observer.observe(error, { attributes: true, attributeFilter: ['class'] });
}());
